
<style scoped lang="scss">
.calendar-wra /deep/ {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 100vw;
    height: 100vh;
    background: $white;
    .calendar {
        td {
            height: 60px;
            &.week {
                color: #808080;
                font-size: 13px;
            }
            &.selected {
                background: #f8b356;
                background-size: 100% 100%;
                border-radius: 10px;
                color: #fff;
                span {
                    background-color: initial;
                    color: inherit;
                }
                .text {
                    color: inherit;
                }
            }
            span {
                font-size: 14px;
                font-weight: bold;
                padding-top: 12px;
                height: auto;
            }

            .text {
                color: $orange;
                font-size: 11px;
                top: 32px;
            }
        }
    }
}
</style>

<template>
    <transition name="fade">
        <div class="calendar-wra" v-show="isOpen">
            <calendar
                :events="prices"
                :zero="true"
                :begin="beginArr"
                :end="endArr"
                :islimit="islimit"
                :saleprice="saleprice"
                @select="select"
            ></calendar>
        </div>
    </transition>
</template>

<script>
import Calendar from "@/components/common/Calendar.vue";
export default {
    name: "SelectDate",
    components: { Calendar },
    props: {
        prices: Object,
        islimit: Boolean,
        saleprice: String,
    },
    data() {
        return {
            isOpen: false,
            beginM: moment(),
        };
    },
    computed: {
        endM() {
            return this.beginM.add(4, "M");
        },
        beginArr() {
            let b = this.beginM.toArray();
            b[1] = b[1] + 1;
            return b.slice(0, 3);
        },
        endArr() {
            let b = this.endM.toArray();
            b[1] = b[1] + 1;
            return this.endM.toArray().slice(0, 3);
        },
    },
    watch: {},
    created() {},
    mounted() {},
    destroyed() {},
    methods: {
        select(value) {
            this.$emit("confirm", value.join("-"));
            this.closeModal();
        },
        closeModal() {
            this.isOpen = false;
        },
        openModal() {
            this.isOpen = true;
        },
    },
};
</script>

